import React from "react"
import Layout from "../components/Layout"
import { graphql } from "gatsby"
import Title from "../components/Title"
import Image from "gatsby-image"
import SEO from '../components/SEO'

const About = ({ data }) => {
  const {
    allStrapiAboutMe: { nodes: aboutMe },
  } = data
  const { title, image, info, stack } = aboutMe[0]
  return (
    <Layout>
      <SEO title ="About" />
      <section className="about-page">
        <div className="section-center about-center">
          <Image fluid={image?.childImageSharp?.fluid} className="about-img" />
          <article className='about-text'>
            <Title title={title} />
            <p>{info}</p>
            <div className="about-stack">
              {stack.map(item => {
                return <span key={item.id}>{item.title}</span>
              })}
            </div>
          </article>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  {
    __typename
    allStrapiAboutMe {
      nodes {
        title
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        stack {
          id
          title
        }
        info
      }
    }
  }
`
export default About
